import React from "react";
import { poster } from "api/tools";
import endPoints from "api/endPoints";

import { useType } from "api/hooks";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

export default () => {
  const location = useLocation();
  const { enginetypeid, gastype, catalyst } = queryString.parse(
    location.search
  );

  const result = useType(enginetypeid);

  const filteredData = result?.data?.types.find(
    (d) => d.name === gastype && d.catalyst_fitted.toString() === catalyst
  );

  React.useEffect(() => {
    if (filteredData?.type_node_id) {
      // warining: no error handling here!
      poster(endPoints.tracker, filteredData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredData?.type_node_id]);

  return null;
};
